import script from "./AcaoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AcaoView.vue?vue&type=script&setup=true&lang=js"

import "./AcaoView.vue?vue&type=style&index=0&id=aece7fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aece7fd4"]])

export default __exports__